import { Injectable } from '@angular/core';
import { Team } from './team.type';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TeamService {
    constructor(
      private http: HttpClient, 
    ) { }

    async get(teamId: string): Promise<Team> {
        const response = await firstValueFrom(this.http.get<Team>('/api/team/' + teamId));
        return response;
    }

    async update(team: Team) {
        const response = await firstValueFrom(this.http.post<Team>('/api/team/' + team.id, team));
        return response;
    }

    async create(teamTemplateId: string, team: Team) {
        const response = await firstValueFrom(this.http.post<Team>('/api/team/new/' + teamTemplateId, team));
        return response;
    }

    async delete(teamId: string) {
        const response = await firstValueFrom(this.http.delete('/api/team/' + teamId));
        return response;
    }

}